module.exports = __webpack_public_path__ + "img/art-slide-5-xl.29cc843.webp";